import { render } from "./ErrorPanel.vue?vue&type=template&id=515f4202"
import script from "./ErrorPanel.vue?vue&type=script&lang=js"
export * from "./ErrorPanel.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__